export default "__VITE_ASSET__9f45c70b__"